import Avatar from '@material-ui/core/Avatar';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import PersonIcon from '@material-ui/icons/Person';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import useTypedSelector from '../../hooks/useTypedSelector';
import { addSnackbar } from '../../store/snacks/snacksActions';

const messageWhatsapp = [
  `Feliz Aniversário! Desejo que seu dia seja todo alegria e no seu coração não falte paz e amor.`,
  `Que hoje toda felicidade do mundo se reúna para abraçar seu coração. Tenha um aniversário muito feliz!`,
  `Feliz aniversário! Que hoje toda felicidade do mundo se reúna para abraçar seu coração.`,
  `Parabéns pelo aniversário, e que a felicidade caminhe ao seu lado a vida toda!`,
];
export default function BirthdayDay() {
  const dispatch = useDispatch();

  const [birthday, setBirthday] = useState('');
  const [cont, setCont] = useState(false);

  const people = useTypedSelector(({ peopleState }) => peopleState.people);
  const searchQuery = useTypedSelector(
    ({ peopleState }) => peopleState.searchQuery
  );

  const peopleBirthday = () => {
    const dateToFormat = new Date();
    const today = moment(dateToFormat).format('MM-DD');
    setBirthday(today);
  };

  useEffect(() => {
    peopleBirthday();
  });

  const filteredPeople = useMemo(() => {
    return people.filter((person) => {
      let birthdayPerson = person.birthday
        ? moment(person.birthday, 'YYYY-MM-DD').format('MM-DD')
        : '';

      if (birthday === birthdayPerson) {
        const result = sessionStorage.getItem('birthday');
        result &&
          dispatch(
            addSnackbar(`Hoje é aniversario de ${person.name}`, {
              variant: 'success',
            })
          );
        setCont(true);

        return person.name.toLowerCase();
      }
      setTimeout(() => {
        sessionStorage.removeItem('birthday');
      }, 200);
      return false;
    });
  }, [birthday, dispatch, people]);

  const { selectedIndex, isEditing, isLoading } = useTypedSelector(
    ({ peopleState }) => {
      return {
        selectedIndex: peopleState.selectedIndex,
        isEditing: peopleState.isEditing,
        isLoading: peopleState.loadingPeople,
      };
    }
  );

  // const onClickItem = (index: number) => () => {
  //   if (!searchQuery) {
  //     dispatch(editingStart(index));
  //   } else {
  //     const person = filteredPeople[index];
  //     const originalIndex = people.findIndex((item) => item.id === person.id);
  //     dispatch(editingStart(originalIndex));
  //   }
  // };

  const renderListItem = (person: any, i: number) => (
    <ListItem
      key={i}
      // button
      // onClick={onClickItem(i)}
      selected={!searchQuery && isEditing && selectedIndex === i}
    >
      <ListItemAvatar>
        {person.image ? (
          <Avatar alt={`Foto de ${person.name}`} src={person.image.sm} />
        ) : (
          <Avatar>
            <PersonIcon />
          </Avatar>
        )}
      </ListItemAvatar>

      <ListItemText
        primary={person.name}
        secondary={
          person.birthday
            ? moment(person.birthday, 'YYYY-MM-DD').format('DD/MM/2020')
            : ''
        }
      />
      <button>
        <div
          style={{
            display: 'flex',
          }}
        >
          <a
            target={'_blank'}
            href={`https://api.whatsapp.com/send?phone=55${person.cellphone.replace(
              /\D+/g,
              ''
            )}&text=${
              messageWhatsapp[
                Math.floor(Math.random() * messageWhatsapp.length)
              ]
            }`}
          >
            <div
              style={{
                width: 40,
                height: 40,
                padding: 5,
                marginRight: 5,
              }}
            >
              <svg
                role="img"
                viewBox="0 0 24 24"
                fill="#25D366"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>WhatsApp</title>

                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
              </svg>
            </div>
          </a>
          <a
            target={'_blank'}
            href={`mailto:${person.email}?subject=${
              messageWhatsapp[
                Math.floor(Math.random() * messageWhatsapp.length)
              ]
            }`}
          >
            <div
              style={{
                width: 40,
                height: 40,
                padding: 5,
                marginLeft: 5,
              }}
            >
              <svg
                role="img"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill="#30B980"
              >
                <title>Minutemailer</title>
                <path d="M17.187 19.181L24 4.755 0 12.386l9.196 1.963.043 4.896 2.759-2.617-2.147-2.076 7.336 4.63z" />
              </svg>
            </div>
          </a>
        </div>
      </button>
    </ListItem>
  );

  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <>
      {!cont ? (
        <div>
          <List>
            <ListItem>
              <ListItemText
                primary="Sem aniversariantes"
                secondary="Caso tenha alguém fazendo aniversario, verifica a data de nascimento no cadastro de membros"
              />
            </ListItem>
          </List>
        </div>
      ) : (
        <>
          <List>{filteredPeople.map(renderListItem)}</List>
        </>
      )}
    </>
  );
}
